import { apiPut } from "../../../utils";

export const updateUserAPI = (data) => {
    return apiPut(`/api/profileDetails`, data);
};
